import { render, staticRenderFns } from "./DumbInput.vue?vue&type=template&id=2816ced4&scoped=true&"
import script from "./DumbInput.vue?vue&type=script&lang=js&"
export * from "./DumbInput.vue?vue&type=script&lang=js&"
import style0 from "./DumbInput.vue?vue&type=style&index=0&id=2816ced4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2816ced4",
  null
  
)

export default component.exports